import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest, ALLOWED_DOMAIN } from "../authConfig";
import "./LoginScreen.css";

export default function LoginScreen() {
  const { instance } = useMsal();
  const login = () => instance.loginRedirect(loginRequest).catch((e) => console.error(e));

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-mark">◆</div>
        <h1 className="login-title">Revenue &amp; Profitability</h1>
        <p className="login-sub">NursePartners Inc. — financial dashboard</p>
        <button className="login-btn" onClick={login}>
          <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
            <path d="M1 1h7.5v7.5H1z" fill="#F25022" />
            <path d="M9.5 1H17v7.5H9.5z" fill="#7FBA00" />
            <path d="M1 9.5h7.5V17H1z" fill="#00A4EF" />
            <path d="M9.5 9.5H17V17H9.5z" fill="#FFB900" />
          </svg>
          Sign in with Microsoft
        </button>
        <p className="login-note">Restricted to @{ALLOWED_DOMAIN} accounts</p>
      </div>
    </div>
  );
}
